import axios from "./axios";
import { setHeaders } from "./baseApi";
import { apiPaths } from "./baseApi";

/**
 * @param {string} [context] - Contexte facultatif
 * @returns {Promise<any>}
 */

export const getAllUsers = async (context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/staff/getAllUsers`,
    { headers: setHeaders(context) },
  );
  return response.data.data;
};

export const getUser = async (id, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/staff/getUser/${id}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const deleteUser = async (id, context) => {
  const response = await axios.delete(
    apiPaths.baseUrl + `/api/staff/deleteUser/${id}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const updateUser = async (payload, id, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/staff/updateUser/${id}`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const recoverAccount = async (email, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/auth/recover-account`,
    { email },
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const createUser = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + "/api/staff/register",
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const resetPassword = async (token, newPassword, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/auth/reset-password/${token}`,
    { newPassword },
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const modifyPassword = async (payload, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/staff/modifyPassword`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const getUserData = async (userID, context) => {
  const response = await axios.get(`${apiPaths}/user/allUser/${userID}`);
  return response.data;
};

// Département
export const getAllDepartment = async (context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/department/getAllDepartment`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const deleteDepartment = async (id, context) => {
  const response = await axios.delete(
    apiPaths.baseUrl + `/api/department/deleteDepartment/${id}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const createDepartment = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + "/api/department/createDepartment",
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const getDepartmentById = async (id, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/department/getDepartmentById/${id}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const updateDepartment = async (payload, id, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/department/updateDepartment/${id}`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// --------------------------Import/Export-------------------------------------------------------

export const importUserProfil = async (payload, context) => {
  console.log("payload envoyé: ", payload);
  const response = await axios.post(
    apiPaths.baseUrl + `/api/importUserProfil`,
    payload,
    {
      headers: {
        ...setHeaders(context),
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return response.data;
};

export const exportUserProfil = async (context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/exporte/user/excel`,
    { headers: setHeaders(context), responseType: "blob" },
  );
  return response.data;
};

export const templateUserProfil = async (context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/download/templateUserProfil`,

    {
      headers: setHeaders(context),

      responseType: "blob",
    },
  );
  return response.data;
};
